import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { t } from '@/lib/i18n';

/**
 * What the writer wants to say about the piece rather than in it.
 *
 * After the end mark and folded shut. Both of those are the same decision: a
 * reader has just finished a poem, and the last thing on the page should be the
 * poem. An account of how it was written is worth offering and worth not
 * imposing — someone who wants it opens it, and someone who does not is left
 * with the ending they were given.
 */
export function AuthorNote({ html }: { html: string }) {
  const [open, setOpen] = useState(false);

  return (
    <section className="mt-8 rounded-lg border bg-muted/30">
      <button
        type="button"
        className="flex w-full items-center gap-2 px-4 py-3 text-start"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
      >
        <ChevronRight className={cn('size-4 shrink-0 text-primary transition-transform', open && 'rotate-90')} />
        <span className="np font-medium">{t('यसको पछाडिको कथा')}</span>
      </button>

      {open && (
        <div
          className="np author-note px-4 pb-4 ps-10 text-[0.97rem] leading-relaxed"
          /* Sanitised server-side on write, exactly as the body is. */
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </section>
  );
}
